import numberWithCommas from '@/utils/numberWithCommas'

const currencyMap = {
    'USD': '$',
    'GBP': '£',
    'EUR': '€'
};

const toCurrency = function (currency_iso_code, cost) {
    let roundedNumber = Math.round(cost)
    let delimitedNumber = numberWithCommas(roundedNumber)
    let currencySymbol = currencyMap[currency_iso_code]
    return currency_iso_code === 'EUR' ? `${delimitedNumber}${currencySymbol}` : `${currencySymbol}${delimitedNumber}`
}

export default toCurrency
